// @ts-nocheck
import React from 'react';
import PropTypes from 'react-proptypes';
import {
  Condition,
  Element,
  Record,
  Feature,
  FormValues,
} from '@fulcrumapp/fulcrum-core';
import TextElementView from '../elements/text-element-view';
import CalculatedElementView from '../elements/calculated-element-view';
import BarcodeElementView from '../elements/barcode-element-view';
import YesNoElementView from '../elements/yes-no-element-view';
import LabelElementView from '../elements/label-element-view';
import TimeElementView from '../elements/time-element-view';
import RepeatableElementView from '../elements/repeatable-element-view';
import HyperlinkElementView from '../elements/hyperlink-element-view';
import RecordLinkElementView from '../elements/record-link-element-view';
import ChoiceField from '../fields/deprecated-choice-field';
import LabeledField from '../fields/labeled-field';
import TextField from '../fields/deprecated-text-field';
import NumberField from '../fields/deprecated-number-field';
import AddressField from '../fields/deprecated-address-field';
import FieldDisplay from '../fields/field-display';
import DateField from '../fields/deprecated-date-field';
import MediaElementField from '../fields/media-element-field';
import FormSection from '../fields/deprecated-form-section';
import { AppContext } from '../../hooks/use-app';
import ClassificationsetField from '../fields/deprecated-classificationset-field';

export default class ElementListView extends React.Component {
  static propTypes = {
    editing: PropTypes.bool.isRequired,
    feature: PropTypes.instanceOf(Feature).isRequired,
    onDrillDownSectionClick: PropTypes.func,
    onFieldChange: PropTypes.func,
    onLinkedRecordSelect: PropTypes.func,
    onLinkedRecordNew: PropTypes.func,
    onLinkedRecordOpen: PropTypes.func,
    onHyperlinkClick: PropTypes.func,
    onRepeatableClick: PropTypes.func,
    onMediaAdd: PropTypes.func,
    onMediaRemove: PropTypes.func,
    onFocusChange: PropTypes.func,
    record: PropTypes.instanceOf(Record),
    rootElement: PropTypes.instanceOf(Element),
    valuesForConditions: PropTypes.instanceOf(FormValues),
  };

  static contextType = AppContext;

  render() {
    const elements = this.props.rootElement ? this.props.rootElement.elements
      : this.props.record.form.elements;

    return (
      <div>
        {this.renderElements(elements)}
      </div>
    );
  }

  renderElements(elements, cache) {
    const visibilityCache = cache || {};

    return elements.map((e) => this.renderElement(e, visibilityCache));
  }

  renderElement(element, visibilityCache) {
    const visible = Condition.shouldElementBeVisible(element,
      this.props.record,
      this.props.valuesForConditions,
      visibilityCache);

    const required = Condition.shouldElementBeRequired(element,
      this.props.record,
      this.props.valuesForConditions);

    const disabled = element.isDisabled;

    const value = this.createValueIfEmpty(element);

    const dataTestID = `element-${element.dataName}`;

    const props = {
      element,
      key: element.key,
      editing: this.props.editing,
      visible,
      required,
      disabled,
      value,
      onChange: this.props.onFieldChange,
      onFocusChange: this.props.onFocusChange,
      record: this.props.record,
    };

    if (element.isSectionElement) {
      return (
        <FormSection
          key={element.label}
          element={element}
          dataTestID={dataTestID}
          visible={props.visible}
          onDrillDownSectionClick={this.props.onDrillDownSectionClick}
        >
          { element.isInline ? this.renderElements(element.elements, visibilityCache) : null}
        </FormSection>
      );
    } if (element.isYesNoElement) {
      return (
        <YesNoElementView {...props} />
      );
    } if (element.isChoiceElement) {
      return (
        <LabeledField
          key={props.key}
          visible={props.visible}
          required={props.required}
          disabled={props.disabled}
          label={props.element.label}
          dataTestID={dataTestID}
          description={props.description || props.element.description}
          bottomBorder={props.element.elements == null}
        >
          {props.editing
            ? (
              <ChoiceField
                value={props.value}
                allowOther={props.element.allowOther}
                disabled={props.disabled}
                onChange={props.onChange}
                choices={props.element.choices}
                multiple={props.element.multiple}
              />
            )
            : <FieldDisplay value={props.value.displayValue} />}
        </LabeledField>
      );
    } if (element.isClassificationElement) {
      return (
        <LabeledField
          key={props.key}
          visible={props.visible}
          required={props.required}
          disabled={props.disabled}
          label={props.element.label}
          dataTestID={dataTestID}
          description={props.description || props.element.description}
          bottomBorder={props.element.elements == null}
        >
          {props.editing
            ? (
              <ClassificationsetField
                classificationItems={props.element.classificationItems}
                value={props.value}
                allowOtherValue={props.element.allowOther}
                disabled={props.disabled}
                onChange={props.onChange}
              />
            )
            : <FieldDisplay value={props.value.displayValue} />}
        </LabeledField>
      );
    } if (
      element.isPhotoElement
        || element.isAudioElement
        || element.isVideoElement
        || element.isSignatureElement
        || element.isAttachmentElement
        || element.isSketchElement) {
      return (
        <MediaElementField
          key={props.key}
          elementKey={props.key}
          element={props.element}
          value={props.value}
          editing={props.editing}
          disabled={props.disabled}
          visible={props.visible}
          required={required}
          feature={this.props.feature}
          record={props.record}
          description={props.description}
          dataTestID={dataTestID}
          onFieldChange={props.onChange}
          onMediaAdd={this.props.onMediaAdd}
          onMediaRemove={this.props.onMediaRemove}
        />
      );
    } if (element.isLabelElement) {
      return (
        <LabelElementView {...props} />
      );
    } if (element.isRepeatableElement) {
      return (
        <RepeatableElementView
          {...props}
          onClick={this.props.onRepeatableClick}
        />
      );
    } if (element.isDateElement) {
      return (
        <LabeledField
          key={props.key}
          visible={props.visible}
          required={props.required}
          disabled={props.disabled}
          dataTestID={dataTestID}
          label={props.element.label}
          description={props.element.description}
          bottomBorder={props.element.elements == null}
        >
          {props.editing
            ? (
              <DateField
                disabled={props.disabled}
                value={props.value}
                onChange={props.onChange}
              />
            )
            : <FieldDisplay value={props.value.displayValue} />}
        </LabeledField>
      );
    } if (element.isTimeElement) {
      return (
        <TimeElementView {...props} />
      );
    } if (element.isAddressElement) {
      return (
        <LabeledField
          key={props.key}
          visible={props.visible}
          required={props.required}
          disabled={props.disabled}
          dataTestID={dataTestID}
          label={props.element.label}
          description={props.description}
          bottomBorder={props.element.elements == null}
        >
          {props.editing
            ? (
              <AddressField
                value={props.value}
                disabled={props.disabled}
                onChange={props.onChange}
              />
            )
            : <FieldDisplay value={props.value.displayValue} />}
        </LabeledField>
      );
    } if (element.isTextElement) {
      return (
        <LabeledField
          key={props.key}
          visible={props.visible}
          required={props.required}
          disabled={props.disabled}
          dataTestID={dataTestID}
          label={props.element.label}
          description={props.element.description}
          bottomBorder={props.element.elements == null}
        >
          {props.editing
            ? this.renderNumOrTextField(props)
            : <FieldDisplay value={props.value.displayValue} />}
        </LabeledField>
      );
    } if (element.isCalculatedElement) {
      return (
        <CalculatedElementView {...props} />
      );
    } if (element.isBarcodeElement) {
      return (
        <BarcodeElementView {...props} />
      );
    } if (element.isHyperlinkElement) {
      return (
        <HyperlinkElementView
          {...props}
          onHyperlinkClick={this.props.onHyperlinkClick}
        />
      );
    } if (element.isRecordLinkElement) {
      return (
        <RecordLinkElementView
          {...props}
          onRecordSelect={this.props.onLinkedRecordSelect}
          onRecordNew={this.props.onLinkedRecordNew}
          onRecordOpen={this.props.onLinkedRecordOpen}
          record={this.props.record}
          valuesForConditions={this.props.valuesForConditions}
        />
      );
    }

    console.log('Unknown element type', element.type);
    return (
      <TextElementView {...props} />
    );
  }

  createValueIfEmpty(element) {
    const value = this.props.feature.formValues.get(element.key);

    if (value != null) {
      return value;
    }

    if (element.isSectionElement || element.isLabelElement) {
      return null;
    }

    return this.props.feature.formValues.createValue(element);
  }

  // eslint-disable-next-line class-methods-use-this
  renderNumOrTextField(
    {
      element,
      disabled,
      value,
      onChange,
      onFocusChange,
    },
  ) {
    return (
      element.isNumeric
        ? (
          <NumberField
            disabled={disabled}
            value={value}
            onChange={onChange}
            onFocusChange={(isFocused) => {
              onFocusChange({ props: { element } }, isFocused);
            }}
          />
        )
        : (
          <TextField
            disabled={disabled}
            value={value}
            onChange={onChange}
            onFocusChange={(isFocused) => {
              onFocusChange({ props: { element } }, isFocused);
            }}
          />
        )
    );
  }
}
